import React,{Component} from 'react';
import "./style.less"
import {NavBar,InputItem,Toast,List} from "antd-mobile";
import {connect} from "react-redux";
import {addPassenger} from "../../../service/passengerService";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class FrequentlyPassenger extends Component{
    constructor(props) {
        super(props);
        this.state={
            name:'',
            phone:'',
            IdCard:'',
            placevalue:0,
            passport:[
                {
                "value":0,
                    "desription":"身份证"
                },
                {
                    "value":1,
                    "desription":"护照"
                },
                {
                    "value":2,
                    "desription":"边民证"
                }
            ],
        }
    }
    infoChange = (v,value) => {
        this.setState({
            [value]:v
        });
    };
    sureAdd = () => {
      
        if(this.state.IdCard.length <= 5){
            Toast.info('证件号不能少于5位数！');
            return
        }else{
            let params = {
                token: this.props.userInfo.token,
                "data": {
                    "name": this.state.name,
                    "phone": this.state.phone.replace(/\s/ig, ''),
                    "idType":this.state.placevalue == 0 ? "idcard" :(this.state.placevalue == 1 ? "passport":"borderCard") ,
                    "idNum":this.state.IdCard,
                    "source":6,
                }
            };
            addPassenger(params)
                .then((res) => {
                    console.log(res)
                    if (res.data.code === '0000') {
                        Toast.info('添加成功！',2,this.props.history.goBack())
                    }
                    else if (res.data.code === '1401') {
                        document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                    }
                    else {
                        Toast.info(res.data.msg);
                    }
                }).catch(function (error) {
                console.log(error);
            });
        }
    }
    show_sub(e){     
        var newVal = e.target.value
        this.setState({
            placevalue:newVal
        })
    }    

    render(){
        return(
            <div className="addFrequentlyPassenger">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >添加</NavBar>
                <div className="content">
                    <List className="passengerInfo">
                        
                        <div className="inputBpx">
                            <i className="icon iconfont iconxingming"></i>
                            <InputItem 
                                placeholder="填写姓名" 
                                value={this.state.name}
                                onChange={(val) => this.infoChange(val, 'name')}
                            ></InputItem>
                        </div>
                        <div className="inputBpx">
                            <i className="icon iconfont iconshouji"></i>
                            <InputItem 
                                type="phone" 
                                placeholder="填写联系手机号" 
                                value={this.state.phone}
                                onChange={(val) => this.infoChange(val, 'phone')}
                            ></InputItem>
                        </div>
                        <div className="inputBpx">
                            <i className="icon iconfont iconshenfenzheng"></i>
                            
                        
                            <select value={this.state.placevalue} onChange={(v)=>this. show_sub(v)}>
                                {this.state.passport.map((res,i)=>(
                                    <option key={i} value={res.value}>{res.desription}</option>
                                ))}
                            
                            </select>
                        
                            <InputItem 
                                maxLength={18} 
                                placeholder={this.state.placevalue == 0 ? "请填写身份证号" :(this.state.placevalue == 1 ? "请填写护照号":"请填写边民证号") }
                                value={this.state.IdCard} 
                                className="card"
                                onChange={(val) => this.infoChange(val, 'IdCard')}
                            ></InputItem>
                        </div>
                    </List>
                </div>
                <button className="addBtn" onClick={()=>this.sureAdd()}>确认添加</button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/AddFrequentlyPassenger/index.js